import http from '@/api/request'

/**
 * 获取会员卡列表
 * @param data
 * @returns {*}
 */
export function vipCardList (data) {
  return http().post('/marketing/api/vip/list', data)
}

/**
 * 根据会员卡id列出会员权益
 * @param id
 * @returns {*}
 */
export function vipSpectificationList (id) {
  return http().get('/marketing/api/vip/specification/list?vipId=' + id)
}

/**
 * 根据会员卡id列出会员权益
 * @param id
 * @returns {*}
 */
export function interestsRefList (id) {
  return http().get('/marketing/api/vip/interests/ref/list?vipId=' + id)
}

/**
 * 会员卡专区列出
 * @param data
 * @returns {*}
 */
export function vipZoneList (data) {
  return http().post('/marketing/api/vip/zone/list', data)
}

export const vipTradeOrderUnified = (data) => {
  return http().post('/marketing/auth/vip/trade/order/unified', data)
}

export const vipTradeRecordStatusView = (params) => {
  return req().get('/marketing/auth/vip/trade/record/status/view', { params })
}

export const vipUserGoodsDiscount = (data) => {
  return http().post('/marketing/api/vip/user/goods/discount', data)
}

export const authVipUserGoodsDiscount = (data) => {
  return http().post('/marketing/auth/vip/user/goods/discount', data)
}

export const userVipList = (data) => {
  return http().post('/marketing/auth/vip/user/list', data)
}
